// @flow

import { Component } from '../jsti/core';
import Template from '../classes/Template';
import Notifications from '../constants/Notifications';
import { buildCartItem, updateStatuses } from '../classes/CartItemHelpers';

export default class CartItems extends Component {
  #template: HTMLElement;

  /**
   * Initialize the component.
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.setUp();

    this.addListener(Notifications.CART_UPDATE_DATA, this.refreshItems);
    this.addListener(Notifications.SUBSCRIPTION_PERIOD_CHANGED, this.updateCartItem);
    this.addListener(Notifications.UPDATE_PRODUCT_COUNTER, this.updateCartItem);
  }

  /**
   * Setup of properties & validation checks.
   */
  setUp(): void {
    const template: HTMLElement | null = this.el.querySelector('template[ref="product"]');
    if (template) {
      this.#template = Template.getContent(template);
    } else {
      throw new Error('A template tag is required');
    }
  }

  /**
   * Refresh the list of items that are in the cart.
   */
  refreshItems(data: Object): void {
    if (Array.isArray(data)) {
      data = data[0];
    }

    const productStatuses: Array<Object> = [];

    // Remove all old items
    while (this.el.firstChild) {
      this.el.removeChild(this.el.firstChild);
    }

    // Append all new items
    for (const item: Object of data.items) {
      this.el.appendChild(buildCartItem(this.#template.cloneNode(true), item));
      productStatuses.push({
        stock: item.stock,
        expectedShippingDate: item.expected_shipping_date,
        amount: item.amount
      });
    }

    // Update all statuses if there are items in the cart
    // This is a separate thing because it requires a async call and we dont want that in the for loop
    if (productStatuses.length) {
      updateStatuses(productStatuses, this.el.children);
    }
  }

  /**
   *
   */
  updateCartItem(data: Object) {
    const cartItem = Array.from(this.el.getElementsByRef('cart-item')).filter((item: HTMLElement) => data.sku === item.dataset.sku)[0];
    if (!cartItem) return;

    const amount = data.amount !== undefined ? data.amount : cartItem.dataset.amount;
    let subscriptionPeriod = data.period !== undefined ? data.period : cartItem.dataset.period;
    if (subscriptionPeriod === 'null') subscriptionPeriod = null;
    const params = {
      sku: data.sku,
      amount,
      difference: data.difference || null,
      subscriptionPeriod,
      location: data.location
    };

    this.notify(Notifications.CART_UPDATE_ITEM, params);
  }
}
